import { createSelector } from "reselect";
import get from "lodash/get";

const eligibilitySettingsDomain = state =>
  get(state, "api.eligibilitySettings.data", {});

const eligiblePlansDomain = state =>
  get(state, "api.eligiblePlans.data[0]", {});

export const makeSelectEligibleServices = () =>
  createSelector(
    eligibilitySettingsDomain,
    eligibilitySettings => eligibilitySettings
  );

export const makeSelectEligibleActions = () =>
  createSelector(
    eligibilitySettingsDomain,
    eligibilitySettings => eligibilitySettings
  );

export const makeSelectEligiblePlansServices = () =>
  createSelector(eligiblePlansDomain, eligiblePlans => eligiblePlans);

// export const makeSelectTerminationEligibility = () =>
//   createSelector(eligibilitySettingsDomain, eligibilitySettings => {
//     return get(eligibilitySettings, "terminate_service", false);
//   });

export const eligibilityActionsStatusSelector = createSelector(
  eligibilitySettingsDomain,
  eligibilityActions => get(eligibilityActions, "actions", null)
);
